export default "__VITE_ASSET__Dw$owFQ4__"